export default __webpack_public_path__ + "static/MarkerMapAndText-de881b7d8ee7fd89be29122b3ef7b103.jpg";